<div class="card" style="border-radius: 10px">
  <div class="card-body">
    <div class="row text-left">
      <div class="col-sm-12">
        <h1 class="text-bold-400" style="color: #4e7977">Consulta Exato — Prova de Vida</h1>
        <p class="mb-3 mt-2" style="font-size: 18px">
          Consulte a prova de vida (vivo / óbito) na Receita Federal a partir de uma lista de CPFs.
          Cole os CPFs separados por vírgula ou envie um arquivo CSV. O processamento é feito em
          lotes de {{ TAMANHO_LOTE }} e ao final é gerado um arquivo .xlsx com os resultados.
        </p>
      </div>
    </div>

    <div class="form-row">
      <div class="col-md-7">
        <div class="form-group">
          <label for="cpfsTexto" style="font-weight: bold">CPFs (separados por vírgula)</label>
          <textarea
            id="cpfsTexto"
            class="form-control"
            rows="6"
            placeholder="Ex.: 12345678901, 98765432100, ..."
            [(ngModel)]="cpfsTexto"
            (ngModelChange)="aoDigitarCpfs()"
            [disabled]="consultaEmAndamento"
          ></textarea>
        </div>
      </div>

      <div class="col-md-5">
        <div class="form-group">
          <label for="arquivoCsv" style="font-weight: bold">Ou envie um arquivo CSV</label>
          <input
            type="file"
            id="arquivoCsv"
            class="form-control-file"
            accept=".csv,text/csv"
            (change)="onArquivoSelecionado($event)"
            [disabled]="consultaEmAndamento"
          />
          <small class="form-text text-muted">
            O arquivo pode ter os CPFs em qualquer coluna; apenas valores de 11 dígitos são considerados.
          </small>
          <p *ngIf="arquivoNome" class="mt-2 mb-0">
            <i class="fa fa-file-text-o mr-1"></i>{{ arquivoNome }}
          </p>
        </div>
      </div>
    </div>

    <div class="form-row align-items-center mt-2">
      <div class="col">
        <span class="badge badge-pill badge-info" style="font-size: 14px;">
          {{ cpfs.length }} CPF(s) válido(s)
        </span>
        <span *ngIf="cpfs.length > 0" class="ml-2 text-muted">
          ({{ origem === 'csv' ? 'arquivo CSV' : 'digitados' }})
        </span>
      </div>
    </div>

    <hr class="my-4" />

    <div class="form-row d-flex justify-content-end align-items-center">
      <div class="col-auto">
        <button
          type="button"
          class="btn btn-outline-secondary mr-2"
          [disabled]="consultaEmAndamento || cpfs.length === 0"
          (click)="limpar()"
        >
          <i class="fa fa-eraser mr-2"></i>Limpar
        </button>
      </div>
      <div class="col-auto">
        <button
          type="button"
          class="btn btn-success"
          [disabled]="consultaEmAndamento || cpfs.length === 0"
          (click)="gerarProvaDeVida()"
        >
          <i class="fa fa-heartbeat mr-2"></i>Gerar prova de vida
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Histórico de consultas -->
<div class="card" style="border-radius: 10px">
  <div class="card-body">
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h4 class="text-bold-400 mb-0" style="color: #4e7977">Consultas realizadas</h4>
      <button type="button" class="btn btn-sm btn-outline-secondary" (click)="carregarConsultas()" [disabled]="carregandoConsultas">
        <i class="fa fa-refresh mr-1"></i>Atualizar
      </button>
    </div>

    <div *ngIf="carregandoConsultas" class="text-center text-muted py-4">
      <i class="fa fa-spinner fa-spin mr-2"></i>Carregando...
    </div>

    <div *ngIf="!carregandoConsultas && consultas.length === 0" class="text-center text-muted py-4">
      Nenhuma consulta realizada ainda.
    </div>

    <div class="table-responsive" *ngIf="!carregandoConsultas && consultas.length > 0">
      <table class="table text-center table-striped" style="font-size: 14px;">
        <thead>
          <tr>
            <th>#</th>
            <th>Data</th>
            <th>Usuário</th>
            <th>Origem</th>
            <th>CPFs</th>
            <th>Vivos</th>
            <th>Óbitos</th>
            <th>Indeterm.</th>
            <th>Erros</th>
            <th>Status</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let c of consultas | slice : (paginaConsultas - 1) * tamanhoPaginaConsultas : (paginaConsultas - 1) * tamanhoPaginaConsultas + tamanhoPaginaConsultas">
            <td class="align-middle">{{ c.id }}</td>
            <td class="align-middle">{{ c.created_at | date: 'dd/MM/yyyy HH:mm' }}</td>
            <td class="align-middle">{{ c.nome_usuario || '-' }}</td>
            <td class="align-middle">{{ c.origem === 'csv' ? 'CSV' : 'Digitados' }}</td>
            <td class="align-middle">{{ c.total_cpfs }}</td>
            <td class="align-middle">{{ c.total_vivos }}</td>
            <td class="align-middle">{{ c.total_obitos }}</td>
            <td class="align-middle">{{ c.total_indeterminados }}</td>
            <td class="align-middle">{{ c.total_erros }}</td>
            <td class="align-middle">
              <span
                class="badge"
                [style.background-color]="c.status === 'concluida' ? '#28a745' : (c.status === 'erro' ? '#dc3545' : '#ffc107')"
                [style.color]="'white'"
              >
                {{ c.status === 'concluida' ? 'Concluída' : (c.status === 'erro' ? 'Erro' : 'Processando') }}
              </span>
            </td>
            <td class="align-middle text-nowrap">
              <button type="button" class="btn btn-sm btn-outline-primary mr-1" (click)="abrirDetalhes(c, detalhesModal)">
                <i class="fa fa-eye mr-1"></i>Detalhes
              </button>
              <button type="button" class="btn btn-sm btn-outline-success" (click)="baixarCsv(c)">
                <i class="fa fa-download mr-1"></i>CSV
              </button>
            </td>
          </tr>
        </tbody>
      </table>

      <div class="d-flex justify-content-end mt-2">
        <ngb-pagination
          *ngIf="consultas.length > tamanhoPaginaConsultas"
          [(page)]="paginaConsultas"
          [pageSize]="tamanhoPaginaConsultas"
          [maxSize]="3"
          [rotate]="true"
          [boundaryLinks]="true"
          size="sm"
          [collectionSize]="consultas.length"
        ></ngb-pagination>
      </div>
    </div>
  </div>
</div>

<!-- Modal de detalhes (itens da consulta) -->
<ng-template #detalhesModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">
      Detalhes da consulta #{{ consultaSelecionada?.id }}
      <small class="text-muted" *ngIf="consultaSelecionada">
        — {{ consultaSelecionada.created_at | date: 'dd/MM/yyyy HH:mm' }}
      </small>
    </h4>
    <button type="button" class="close" aria-label="Fechar" (click)="modal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div *ngIf="carregandoItens" class="text-center text-muted py-4">
      <i class="fa fa-spinner fa-spin mr-2"></i>Carregando itens...
    </div>

    <div *ngIf="!carregandoItens && itensConsulta.length === 0" class="text-center text-muted py-4">
      Nenhum item encontrado para esta consulta.
    </div>

    <div class="table-responsive" *ngIf="!carregandoItens && itensConsulta.length > 0">
      <table class="table text-center table-striped" style="font-size: 13px;">
        <thead>
          <tr>
            <th>Nome</th>
            <th>CPF</th>
            <th>Prova de Vida</th>
            <th>Consta Óbito</th>
            <th>Situação Cadastral</th>
            <th>Data de Óbito</th>
            <th>Nome na Receita Federal</th>
            <th>Data de Nascimento</th>
            <th>Observação</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let it of itensConsulta">
            <td class="align-middle">{{ it.nome || '-' }}</td>
            <td class="align-middle">{{ it.cpf }}</td>
            <td class="align-middle">
              <span
                class="badge"
                [style.background-color]="it.prova_de_vida === 'Vivo' ? '#28a745' : (it.prova_de_vida === 'Óbito' ? '#dc3545' : '#6c757d')"
                [style.color]="'white'"
              >
                {{ it.prova_de_vida || '-' }}
              </span>
            </td>
            <td class="align-middle">{{ it.consta_obito === 1 ? 'Sim' : (it.consta_obito === 0 ? 'Não' : '-') }}</td>
            <td class="align-middle">{{ it.situacao_cadastral || '-' }}</td>
            <td class="align-middle">{{ it.data_obito || '-' }}</td>
            <td class="align-middle">{{ it.nome_receita_federal || '-' }}</td>
            <td class="align-middle">{{ it.data_nascimento || '-' }}</td>
            <td class="align-middle text-left">{{ it.erro || '-' }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-success" (click)="baixarCsv(consultaSelecionada)" [disabled]="carregandoItens || itensConsulta.length === 0">
      <i class="fa fa-download mr-1"></i>Baixar CSV
    </button>
    <button type="button" class="btn btn-secondary" (click)="modal.close()">Fechar</button>
  </div>
</ng-template>

<!-- Overlay de progresso (lote a lote) -->
<div
  *ngIf="consultaEmAndamento"
  class="d-flex justify-content-center align-items-center"
  style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0, 0, 0, 0.8); z-index: 99999;"
>
  <div class="text-center text-white" style="max-width: 480px; width: 90%;">
    <i class="fa fa-heartbeat fa-3x mb-3" style="color: #28a745;"></i>
    <h4 class="text-white">Consultando prova de vida...</h4>
    <p class="mb-2">
      Processando {{ processados }} de {{ total }}
      <span *ngIf="totalLotes">(lote {{ loteAtual }} de {{ totalLotes }})</span>
    </p>
    <div class="progress" style="height: 22px;">
      <div
        class="progress-bar progress-bar-striped progress-bar-animated bg-success"
        role="progressbar"
        [style.width.%]="progressoPercentual()"
        [attr.aria-valuenow]="progressoPercentual()"
        aria-valuemin="0"
        aria-valuemax="100"
      >
        {{ progressoPercentual() }}%
      </div>
    </div>
    <p class="mt-3 mb-0" style="font-weight: bold; color: #ffc107;">
      <i class="fa fa-exclamation-triangle mr-1"></i>
      Não feche nem saia desta página enquanto o processamento estiver em andamento.
    </p>
  </div>
</div>
